<template>
  <layout-user :no-footer="true">
    <div class="ai-inspiration">
      <div class="reference">
        <div class="reference-cont">
          <div class="close" @click="$router.push('/new-design')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="back()">
              <path d="M18 18L6 6" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 6L6 18" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Close
          </div>
          <div class="reference__title">
            <p>Design reference</p>
            <!-- <p class="upload-btn">Upload from library...</p> -->
          </div>
          <div class="upload-img-block">
            <!-- <p class="upload-img-block__title" v-if="imgFront && imgBack">Fashion technical drawing of flared trousers</p> -->
            <div class="upload-img">
              <div :class="`${errors.imgFront ? 'error' : ''} upload-img__upload`">
                <input type="file" name="svg-file" accept="image/*" @change="addImg($event, 'imgFront')">
                <img v-if="imgFront?.url" :src="imgFront.url" alt="frontImg" class="preview-image">
                <div class="side">Front</div>
                <div :class="`${imgFront ? 'svg-button' : ''}`">
                  <ButtonIcon class="secondary small">
                    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
                      <path d="M15 18.3H5c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h10c.4 0 .8.3.8.8s-.4.8-.8.8zm-5-3.4c-.4 0-.8-.3-.8-.8V2.5c0-.4.3-.8.8-.8s.8.3.8.8v11.7c0 .4-.4.7-.8.7z" class="st0"/>
                      <path d="M14.2 7.4c-.2 0-.4-.1-.5-.2L10 3.6 6.4 7.2c-.3.3-.8.3-1.1 0s-.3-.8 0-1.1L9.5 2c.3-.3.8-.3 1.1 0l4.2 4.2c.3.3.3.8 0 1.1-.2 0-.4.1-.6.1z" class="st0"/>
                    </svg>
                  </ButtonIcon>
                  <div class="tooltiptext" v-if="imgFront">Upload</div>
                </div>
              </div>
              <div :class="`${errors.imgBack ? 'error' : ''} upload-img__upload`">
                <input type="file" name="svg-file" accept="image/*" @change="addImg($event, 'imgBack')">
                <img v-if="imgBack?.url" :src="imgBack.url" alt="backImg" class="preview-image">
                <div class="side">Back</div>
                <div :class="`${imgBack ? 'svg-button' : ''}`">
                  <ButtonIcon class="secondary small">
                    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
                      <path d="M15 18.3H5c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h10c.4 0 .8.3.8.8s-.4.8-.8.8zm-5-3.4c-.4 0-.8-.3-.8-.8V2.5c0-.4.3-.8.8-.8s.8.3.8.8v11.7c0 .4-.4.7-.8.7z" class="st0"/>
                      <path d="M14.2 7.4c-.2 0-.4-.1-.5-.2L10 3.6 6.4 7.2c-.3.3-.8.3-1.1 0s-.3-.8 0-1.1L9.5 2c.3-.3.8-.3 1.1 0l4.2 4.2c.3.3.3.8 0 1.1-.2 0-.4.1-.6.1z" class="st0"/>
                    </svg>
                  </ButtonIcon>
                  <div class="tooltiptext" v-if="imgBack">Upload</div>
                </div>
              </div>
            </div>
            <p v-if="!imgFront || !imgBack">Upload or drag & drop sketch file or image</p>
            <div class="error-message" v-if="errors.imgBack || errors.imgFront">
              <svg class="error-message__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9Zm0-10v5"/>
                <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9502 8h.1v.1h-.1V8Z"/>
              </svg>
              <p>Please add all necessary references.</p>
              <svg @click="delErrors" class="error-message__close" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16">
                <path stroke="#FFCBCB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 12 4 4m8 0-8 8"/>
              </svg>
            </div>
          </div>
          <!-- <div class="tags">
            <div class="tag">
              women’s pants
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="20" height="20">
                <path stroke="#6F8789" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.3333 13.3332 6.66663 6.6665m6.66667 0-6.66667 6.6667"/>
              </svg>
            </div>
            <div class="tag">
              no pockets
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="20" height="20">
                <path stroke="#6F8789" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.3333 13.3332 6.66663 6.6665m6.66667 0-6.66667 6.6667"/>
              </svg>
            </div>
          </div> -->
          <Dropdown
            :options="[{name: 'Woven'}, {name: 'Knit'}]"
            v-model="fabric"
            label="Settings"
            :noButtonText="true"
            option-label="name"
          >
            <template v-slot:button_text>
              <p>Fabric</p>{{fabric.name}}
            </template>
          </Dropdown>
          <TextareaField v-model="include" placeholder="What should the design include?" style="margin-bottom: 12px;">
            <template v-slot:top-label>
              Design preferences (optional)
            </template>
          </TextareaField>
          <TextareaField v-model="avoided" placeholder="What should be avoided?" />
          <ButtonPrimary
            class="small"
            @click.native="send()"
          >
            Create
          </ButtonPrimary>
        </div>
      </div>
      <div class="designs">
        <div class="designs-cont">
          <div v-if="aiDesignerStore.loading" class="loading-state">
            <svg class="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
              <g clip-path="url(#clip0_719_13172)">
                <path d="M21 10.5V5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 21H5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                  d="M13.5623 13.5625L9.7998 9.79999" stroke="#09373D" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_719_13172">
                  <rect width="42" height="42" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <p class="loading-text">Generating design options…</p>
          </div>
          <template v-else-if="!aiDesignerStore.loading && aiDesignerStore.designs.length">
            <div class="designs__title">Here’s your designs!</div>
            <p>Choose one to continue. Or save the design(s) to continue later.</p>
            <div class="options-cont">
              <div  class="options">
                <div class="options__item"
                  v-for="(design, index) in aiDesignerStore.designs" :key="design.id"
                >
                  <div class="options__item__title">
                    <p class="size-name">#{{ index + 1 }}</p>
                    <div>
                      <ButtonIcon class="secondary small">
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
                          <path d="M16.7 18.3H3.3c-.9 0-1.6-.7-1.6-1.6V3.3c0-.9.7-1.6 1.6-1.6h10c.4 0 .9.2 1.2.5l3.3 3.7c.3.3.4.7.4 1.1v9.7c0 .8-.7 1.6-1.5 1.6zM3.3 3.3s-.1 0 0 0l-.1 13.4s0 .1.1.1h13.3s.1 0 .1-.1V7l-3.3-3.7H3.3z"/>
                          <path d="M14.2 18.3H5.8c-.4 0-.8-.3-.8-.8v-5c0-.9.7-1.6 1.6-1.6h6.7c.9 0 1.6.7 1.6 1.6v5c0 .4-.3.8-.7.8zm-7.6-1.5h6.8v-4.2s0-.1-.1-.1H6.7s-.1 0-.1.1v4.2zm5.9-10.2h-5c-.4 0-.8-.3-.8-.8S7 5 7.5 5h5c.4 0 .8.3.8.8s-.4.8-.8.8z"/>
                        </svg>
                      </ButtonIcon>
                      <ButtonIcon class="primary small" style="margin-left:8px;" @click.native="openDesign(design)">
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
                          <path d="M15.8 10.8H4.2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h11.7c.4 0 .8.3.8.8s-.5.8-.9.8z"/>
                          <path d="M10.8 15.8c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l4.5-4.5-4.5-4.5c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l5 5c.3.3.3.8 0 1.1l-5 5c-.2.2-.4.3-.6.3z"/>
                        </svg>
                      </ButtonIcon>
                    </div>
                  </div>
                  <div v-if="design.loading" class="options__loader">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                      <g clip-path="url(#clip0_719_13172)">
                        <path d="M21 10.5V5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.5 21H5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                          d="M13.5623 13.5625L9.7998 9.79999" stroke="#09373D" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_719_13172">
                          <rect width="42" height="42" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="options__item__svg" v-else-if="design.designOptions">
                    <sketch-image
                      noUpdate
                      :design-options="design.designOptions"
                      :elements="design.elements"
                      :desc-items="[]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ButtonSecondary
              class="small load-more"
              @click.native="aiDesignerStore.getDesigns($route.params.category)"
            >
              Load more
              <template v-slot:lastIcon v-if="aiDesignerStore.loadMore">
                <svg class="loading" xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none"><path stroke="#6F8789" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 5.917v-2.5M13.542 7.375l1.792-1.791M15 10.917h2.5M13.542 14.459l1.792 1.791M10 15.917v2.5M6.459 14.459 4.667 16.25M5 10.917H2.5M6.459 7.375 4.667 5.584"/></svg>
              </template>
            </ButtonSecondary>
          </template>
          <template v-else>
            <div class="designs__title">Create from inspiration<div class="ai">AI</div></div>
            <p>Upload a sketch or image and we’ll reconstruct it in the most similar way available in our data set, generating multiple options to start from.</p>
            <div class="img-appear">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.6667 5.3335H5.33333C4.59695 5.3335 4 5.93045 4 6.66683V25.3335C4 26.0699 4.59695 26.6668 5.33333 26.6668H26.6667C27.403 26.6668 28 26.0699 28 25.3335V6.66683C28 5.93045 27.403 5.3335 26.6667 5.3335Z" stroke="#6F8789" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 22.6666L10.9733 14.531C11.5103 13.9045 12.4817 13.9113 13.01 14.5452L17.732 20.2116C18.2339 20.8139 19.1447 20.8552 19.6991 20.3008L21.6133 18.3866C22.1752 17.8247 23.1008 17.876 23.5973 18.4965L28 23.9999" stroke="#6F8789" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18.6666 11.9998C18.6666 11.2635 19.2636 10.6665 20 10.6665C20.7363 10.6665 21.3333 11.2635 21.3333 11.9998C21.3333 12.7362 20.7363 13.3332 20 13.3332C19.2636 13.3332 18.6666 12.7362 18.6666 11.9998Z" stroke="#6F8789" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Your designs will appear here
            </div>
          </template>
        </div>
      </div>
    </div>
  </layout-user>
</template>

<script>
import { mapStores } from 'pinia'
import { useAiDesignerStore } from '@/store/pinia/aiDesugner'
import LayoutUser from '@/layouts/LayoutUser'
import TextareaField from '@/components/Atoms/TextareaField.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import ButtonIcon from '@/components/Atoms/ButtonIcon.vue'
import Dropdown from '@/components/Atoms/Dropdown.vue'
import SketchImage from '@/components/Sketch/SketchImage.vue'

export default {
  name: 'AiInspiration',
  components: {
    LayoutUser,
    TextareaField,
    ButtonPrimary,
    Dropdown,
    ButtonIcon,
    SketchImage,
    ButtonSecondary,
  },
  data: () => ({
    include: null,
    avoided: null,
    fabric: { name: 'Woven' },
    fabricOptions: [],
    imgFront: null,
    imgBack: null,
    errors: {
      imgFront: false,
      imgBack: false,
    },
    map: {
      'straight': [1, 52, 53, 4, 1020, 28, 42, 3537, 102, 42],
      'straps': [1, 52, 53, 185, 226, 22, 103, 102, 4275],
      'shirt': [1, 52, 4, 1020, 28, 1133, 116, 1126, 271],
      'square': [1, 52, 53, 4, 1020, 31, 3540, 102, 3615, 293],
      'off shoulder': [55, 52, 53, 3517, 26, 990, 97, 3677],
      'wrap': [147, 52, 53, 4, 1020, 17, 3537, 102, 279, 3651],
      'sleeveless': [1, 52, 53, 4, 1020, 17, 3537, 102, 3595, 3624],
      'navy': [1, 3, 4, 20, 97, 293, 4039],
      'grey': [1, 293, 4, 17, 975, 3672],
    },
  }),
  computed: {
    ...mapStores(useAiDesignerStore),
  },
  mounted () {
    // Reset designs when entering the page to start fresh
    this.aiDesignerStore.resetForAiInspiration()
  },
  methods: {
    addImg (e, side) {
      const file = e.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (event) => {
          const fileName = file.name.toLowerCase()
          const matchedKey = Object.keys(this.map).find(key => fileName.includes(key))
          if (matchedKey) {
            this.aiDesignerStore.checked[0] = this.map[matchedKey]
          }
          this[side] = {
            name: file.name,
            type: file.type,
            url: event.target.result,
          }
        }
        reader.readAsDataURL(file)
      }
    },
    openDesign (data) {
      this.$router.push(
        {
          name: 'PageDesigner',
          params: {
            designCategory: this.$route.params.category,
            mannequinId: this.$route.query.mannequinId,
            mannequinType: this.$route.query.mannequinType,
            mannequinName: this.$route.query.mannequinName,
            fitChartsIsCustom: this.$route.query.fitChartsIsCustom,
            mannequinIdNew: this.$route.query.mannequinIdNew,
            fitChartsId: this.$route.query.fitChartsId,
            elementIds: data.designOptions.elementIds,
            isAiDesign: true,
          },
        },
      )
    },
    delErrors () {
      this.errors = {
        imgFront: false,
        imgBack: false,
      }
    },
    send () {
      this.aiDesignerStore.resetForAiInspiration()
      this.delErrors()
      if (!this.imgFront) this.errors.imgFront = true
      if (!this.imgBack) this.errors.imgBack = true
      if (this.errors.imgFront || this.errors.imgBack) return false
      this.aiDesignerStore.getDesigns(this.$route.params.category)
    },
  },
}
</script>

<style lang="scss">
.ai-inspiration {
  display: flex;
  height: 100%;
  font-size: 14px;
  color: var(--Text-Text_Secondary);
  p {
    margin: 0;
  }
  .reference {
    border-right: 1px solid var(--Dividers);
    background: var(--Surface);
    width: 458px;
    height: calc(100vh - 60px);
    overflow: scroll;
    .reference-cont {
      padding: 24px 16px 16px;
    }
    .tags {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      margin-top: 8px;
      color: var(--Primary-Shades-Primary);
      .tag {
        display: flex;
        align-items: center;
        padding: 6px;
        gap: 4px;
        border-radius: 8px;
        border: 1px solid var(--Dividers, #E0E9EA);
        background: var(--Basic-White, #FFF);
      }
    }
    .close {
      display: flex;
      gap: 4px;
      align-items: center;
      color: var(--Primary-Shades-Primary, #09373D);
      font-weight: 600;
      cursor: pointer;
    }
    &__title {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
      .upload-btn {
        color: var(--Primary-Shades-Primary);
        font-weight: 600;
      }
    }
    .upload-img-block {
      margin-top: 8px;
      padding: 16px;
      border-radius: 12px;
      border: 1px solid var(--Dividers);
      background: var(--Background);
      text-align: center;
      &__title {
        overflow: hidden;
        color: var(--Text-Text_Primary);
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        margin-bottom: 16px;
      }
      .upload-img {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        .preview-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        &__upload.error {
          border: 1px solid var(--System-Error);
        }
        &__upload {
          margin-bottom: 8px;
          border-radius: 6px;
          border: 1px solid var(--Dividers, #E0E9EA);
          background: var(--Surface-Hover, #F1F5F6);
          height: 164px;
          width: calc(50% - 6px);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          &:hover {
            .svg-button {
              display: block;
            }
          }
          .tooltiptext {
            top: calc(100% + 13px);
            background-color: #09373D;
            color: #fff;
            text-align: center;
            border-radius: 8px;
            padding: 4px 10px;
            position: absolute;
            z-index: 1;
            transform: translateX(-50%);
            width: max-content;
            left: 50%;
            transition: opacity 0.3s;
            font-size: 12px;
            &::after {
              content: '';
              position: absolute;
              bottom: 100%;
              left: 50%;
              margin-left: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: transparent transparent #09373D transparent;
            }
          }
          .svg-button {
            position: absolute;
            top: 8px;
            right: 8px;
            display: none;
          }
          .side {
            padding: 4px 8px;
            border-radius: 40px;
            background: var(--Dividers);
            position: absolute;
            top: 8px;
            left: 8px;
            color: var(--Text-Text_Primary);
          }
          input[type="file"] {
            position: absolute;
            width: 100%;
            height: 100%;
            font-size: 0;
            background-color: rgba(0,0,0,0);
            cursor: pointer;
            z-index: 100;
            &::file-selector-button {
              display: none;
            }
          }
        }
      }
    }
    .base-dropdown {
      margin: 24px 0;
      &__label {
        font-size: 14px !important;
      }
    }
    .textarea-field {
      .top-label {
        font-size: 14px;
      }
      textarea {
        max-width: 100%;
        min-height: 92px;
      }
    }
    .btn {
      width: 100%;
      margin-top: 30px;
    }
    .button_text {
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      p {
        color: var(--Text-Text_Secondary);
      }
    }
    .error-message {
      display: flex;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #FFCBCB;
      background: rgba(245, 39, 39, 0.05);
      color: var(--System-Error);
      padding: 12px;
      gap: 16px;
      text-align: left;
      margin-top: 16px;
      p {
        width: 100%;
      }
      &__icon {
        min-width: 24px;
      }
      &__close {
        cursor: pointer;
        min-width: 16px;
      }
    }
  }
  .designs {
    background: var(--Background);
    height: 100%;
    width: calc(100% - 458px);
    height: calc(100vh - 60px);
    overflow: scroll;
    .designs-cont {
      padding: 24px 0 24px 24px;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .loading-state {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      .loading-spinner {
        animation: spin 1.5s linear infinite;
      }
      .loading-text {
        color: var(--Text-Text_Secondary);
        font-size: 14px;
      }
    }
    &__title {
      display: flex;
      align-items: center;
      color: var(--Text-Text_Primary);
      font-family: Unbounded;
      font-size: 16px;
      font-weight: 600;
      gap: 4px;
      margin-bottom: 8px;
      max-width: 580px;
      .ai {
        font-family: 'DM Sans';
        font-weight: 400;
        font-size: 12px;
        border-radius: 40px;
        background: var(--Dividers, #E0E9EA);
        width: 33px;
        height: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .img-appear {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 16px;
    }
    .load-more {
      margin: 0 auto;
      min-height: 40px;
      .loading {
        animation: spin 2s linear infinite;
      }
    }
    .options-cont {
      overflow: scroll;
    }
    .options {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin: 20px 0 24px;
      max-width: 1500px;
      padding-right: 24px;
      &__loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100% - 40px);
        svg {
          animation: spin 1.5s linear infinite;
        }
      }
      &__item:hover {
        .options__item__title {
          display: flex;
        }
      }
      &__item {
        height: 280px;
        width: 280px;
        border-radius: 12px;
        border: 1px solid var(--Dividers);
        padding: 8px;
        position: relative;
        overflow: hidden;
        &__title {
          display: none;
          gap: 8px;
          justify-content: space-between;
          background: linear-gradient(180deg, rgba(29, 31, 41, 0.40) 0%, rgba(29, 31, 41, 0.00) 100%);
          top: 0;
          left: 0;
          width: 100%;
          padding: 8px;
          position: absolute;
          height: 69px;
          .size-name {
            font-size: 16px;
            color: var(--Text-Text_White);
            padding: 4px;
          }
        }
        &__svg {
          margin-top: 8px;
          padding: 0 8px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            overflow: visible;
            width: 100%;
            height: 100%;
          }
        }
      }
      &__item.active {
        border: 1px solid#FF6770;
        .auto_grading__item__title {
          color: #FF6770;
          font-weight: 600;
        }
      }
    }
  }
}
@media (max-width: 1400px) {
  .ai-inspiration .designs .options__item {
    height: 164px;
    width: 164px;
  }
}
@media (max-width: 856px) {
  .ai-inspiration {
    .reference {
      width: 250px;
      .upload-img-block .upload-img__upload {
        width: 100%;
      }
    }
    .designs {
      width: calc(100% - 250px);
    }
  }
}
@media (max-width: 656px) {
  .ai-inspiration {
    flex-direction: column;
    height: auto;
    .reference {
      width: 100%;
      height: auto;
      .upload-img-block .upload-img__upload {
        width: calc(50% - 6px);
      }
    }
    .designs {
      width: 100%;
      height: auto;
    }
  }
}
</style>
